import { ProductListComponent } from '../product-list.component';
import { Component, inject } from '@angular/core';
import { RootReducer, Store } from '@app/app.reducers';
import { DataLayer } from '@app/shared/services/data-layer.service';

@Component({
	selector: 'g-product-list-thumbnail',
	templateUrl: './product-list-thumbnail.component.html',
	styleUrls: ['./product-list-thumbnail.component.scss', '../product-list.component.scss'],
	standalone: false,
})
export class ProductListThumbnailComponent extends ProductListComponent {
	protected store: Store<RootReducer.State>;
	protected dataLayer: DataLayer;

	constructor() {
		super();
		this.store = inject<Store<RootReducer.State>>(Store);
		this.dataLayer = inject(DataLayer);
	}
}
